// Libraries
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import clsx from "clsx";

// Constants
import { CUSTOMER_TYPES } from "../../../constants";

// Types
import { TCustomerType } from "@/DataPages/context/crm/interfaces";

// Helpers
import { isIndividual, transformCustomerType } from "../../../helpers";

// Context
import { useLeadsContext } from "@/DataPages/context/crm/LeadsContext";

export default function CustomerTypeRadioGroup() {
	const { isSavingLead, onChangeContext, getContextValue } = useLeadsContext();

	return (
		<RadioGroup
			className={clsx("flex !flex-row gap-4 w-full -mt-4", {
				"[&_.MuiFormControlLabel-label]:font-sans": true,
				"[&_.MuiFormControlLabel-label]:font-[400]": true,
				"[&_.MuiFormControlLabel-label]:text-[14.5px]": true,
				"[&_.MuiFormControlLabel-label]:text-[#666666]": true,
			})}
			defaultValue={"individual"}
		>
			{CUSTOMER_TYPES.map((type) => (
				<FormControlLabel
					key={`customer-type-${type}`}
					value={type}
					control={
						<Radio
							checked={getContextValue("customer", "type") === type}
							onChange={(value) => {
								onChangeContext<TCustomerType>("customer", "type", value.target.value as TCustomerType);

								if (isIndividual(value.target.value as TCustomerType)) {
									const currentFirstInputName = (getContextValue("customer", "firstInputName") as string).substring(
										0,
										30
									);
									onChangeContext<string>("customer", "firstInputName", currentFirstInputName);
								}
							}}
						/>
					}
					label={transformCustomerType(type)}
					disabled={isSavingLead}
				/>
			))}
		</RadioGroup>
	);
}
